import React from 'react';
import ReactDOM from 'react-dom';

import { CircularProgress } from '@material-ui/core';

import { Wrapper } from './styled';

type LoadingFullProps = {
  open: boolean;
  zIndex?: number;
  allowInteraction?: boolean;
  size?: number;
  color?: 'primary' | 'secondary' | 'inherit';
};

const LoadingFull: React.FC<LoadingFullProps> = ({
  open,
  zIndex = 2000,
  allowInteraction = false,
  size = 64,
  color = 'primary',
}) => {
  if (!open) return null;

  return ReactDOM.createPortal(
    <Wrapper role="status" aria-live="polite" aria-busy="true" zIndex={zIndex} allowInteraction={allowInteraction}>
      <CircularProgress size={size} color={color} />
    </Wrapper>,
    document.body
  );
};

export default LoadingFull;
